import classNames from 'classnames';
import React from 'react';
import styles from './Header.module.scss';
function Header({ size = 's', icon, aside, children }) {
    const classes = classNames(styles.wrap, styles[size]);
    if (aside) {
        return (React.createElement("div", { className: styles.wrapAside },
            React.createElement("h2", { className: classes },
                icon && React.createElement("span", { className: styles.icon }, icon),
                children),
            React.createElement("aside", { className: styles.aside }, aside)));
    }
    return (React.createElement("h2", { className: classes },
        icon && React.createElement("span", { className: styles.icon }, icon),
        children));
}
export default Header;
